// A setting with a few named values: the label at the left, a button at the
// right reading the current value. A tap moves to the next value.
import { Button } from './Button';

interface Props<T extends string> {
  label: string;
  value: T;
  values: readonly T[];
  onChange: (value: T) => void;
}

export function SettingButton<T extends string>({ label, value, values, onChange }: Props<T>) {
  const next = values[(values.indexOf(value) + 1) % values.length]!;
  return (
    <div className="toggle setting-button">
      <span className="toggle-label">{label}</span>
      <Button variant="ghost" small aria-label={`${label}: ${value}`} onClick={() => onChange(next)}>
        {value}
      </Button>
    </div>
  );
}
